import axios from 'axios';
import { API_LIST } from './api-list';
import { constants } from '../constants/constants';

export class ServiceCaller {
    // Axios is a promise based HTTP client for the browser and node.js
    // Axios is a library that allows you to make HTTP requests from the browser

    private baseUrl = constants.BASE_URL;

    public async getPortfolioData() {
        try {
            const response = await axios.get(`${this.baseUrl}${API_LIST.GET_PORTFOLIO_DATA}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching personal details:', error);
            throw error;
        }
    }

    public async sendEmailRequest(name: string, email: string, subject: string, message: string) {
        try {
            const contactUrl = process.env.NODE_ENV === 'production'
                ? API_LIST.SEND_EMAIL_REQUEST
                : `${this.baseUrl}${API_LIST.SEND_EMAIL_REQUEST}`;
            const response = await axios.post(
                contactUrl,
                { name, email, subject, message },
                { timeout: 10000 }
            );
            return response.data;
        } catch (error) {
            console.error('Error sending email:', error);
            throw error;
        }
    }
}
